import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { Headset } from 'src/models';
import { RootState } from 'src/store';
import { headsetsSelectors } from 'src/store/reducers/headsets';

export const useHeadsetsState = (): RootState['headsets'] => {
  const state = useSelector<RootState, RootState['headsets']>(
    (state) => state.headsets,
  );

  useDebugValue(state);

  return state;
};

export const useHeadsetActivationCode = (): string | null => {
  const state = useSelector<RootState, RootState['headsets']>(
    (state) => state.headsets,
  );
  const activationCode = state.activationCode?.code ?? null;

  useDebugValue(activationCode);

  return activationCode;
};

export const useHeadsets = (): Headset[] => {
  const state = useSelector<RootState, RootState['headsets']>(
    (state) => state.headsets,
  );

  const headsets = headsetsSelectors.selectAll(state);

  useDebugValue(headsets);

  return headsets;
};

export const useHeadsetById = (headsetId: string): Headset | undefined => {
  const state = useSelector<RootState, RootState['headsets']>(
    (state) => state.headsets,
  );

  const headset = headsetsSelectors.selectById(state, headsetId);

  useDebugValue(headset);

  return headset;
};
